import {
  CANDIDATE_OVERVIEW_UPDATE_REQUEST,
  CANDIDATE_OVERVIEW_UPDATE_SUCCESS,
  CANDIDATE_OVERVIEW_UPDATE_FAIL,

} from "../constants/AuthConstant";

const initialState = {
  loading: false,
  action: "DASHBOARDCONTENT",
  result: [],
  response: {},
  msg: "",
  error: "",
};

const DashboardOverviewReducer = (state = initialState, action) => {
  switch (action.type) {

    case CANDIDATE_OVERVIEW_UPDATE_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case CANDIDATE_OVERVIEW_UPDATE_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        //   result: state.result.map((item) =>
        // item.candidateId === action.result.data.candidateId ? action.result.data : item
        //   ),
        response: action.result.msg,
        singledata: [],
        loading: action.payload,

        msg: action.msg,
      };
    case CANDIDATE_OVERVIEW_UPDATE_FAIL:
      return {
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };

    default:
      return state;
  }
};

export default DashboardOverviewReducer;
